import { getProgressRepository } from '../storage/context.js';
import { Progression } from './progression.js';

let instance: Progression | undefined;

export async function initProgression(): Promise<Progression> {
  if (instance) return instance;
  instance = await Progression.create(getProgressRepository());
  return instance;
}

export function getProgression(): Progression {
  if (!instance) throw new Error('Progression not initialised; call initProgression() first');
  return instance;
}

export function _resetProgressionForTests(): void {
  instance = undefined;
}
